import React from 'react';
import './Header.css'
const Header = () => {
    return (
        <div className='my-10'>
            <div>
                <img className='img-width' src="https://www.educative.io/v2api/editorpage/4807683539468288/image/5379198832082944" alt="" />
                <p className='img-width text-2xl text-blue-500 bg-blue-200'>React Router is a standard library for routing in React. It enables the navigation among views of various components in a React Application, allows changing the browser URL, and keeps the UI in sync with the URL. </p>
            </div>
        </div>
    );
};

export default Header;